import { Globe } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

/**
 * LanguageToggle — single button in the navbar that flips HE ↔ EN.
 * The label always shows the OTHER language so it's clear what clicking
 * will do (e.g. when in Hebrew you see "English", click → switches to EN).
 */
export default function LanguageToggle({ className = "", compact = false }) {
  const { lang, toggle } = useLanguage();
  const target = lang === "he" ? "EN" : "עב";
  const targetFull = lang === "he" ? "English" : "עברית";

  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      aria-label={`Switch to ${targetFull}`}
      title={`Switch to ${targetFull}`}
      className={`inline-flex items-center justify-center gap-1.5 px-3 py-2 min-h-[40px] rounded-sm border border-border/60 hover:border-gold/60 hover:text-gold transition-colors text-xs font-heading uppercase tracking-wider ${className}`}
    >
      <Globe className="h-3.5 w-3.5" strokeWidth={1.5} />
      {compact ? target : targetFull}
    </button>
  );
}
